import { render, staticRenderFns } from "./SvgGeorgia.vue?vue&type=template&id=d5ecd50a&"
var script = {}
import style0 from "./SvgGeorgia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports